import { useState, useEffect } from 'react';

export default function CountdownLoader({ duration = 6, onComplete = () => { } }) {
    const [timeLeft, setTimeLeft] = useState(duration);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (timeLeft <= 0) {
            onComplete();
            return;
        }

        const timer = setTimeout(() => {
            setTimeLeft(timeLeft - 1);
            setProgress(((duration - timeLeft + 1) / duration) * 100);
        }, 1000);

        return () => clearTimeout(timer);
    }, [timeLeft, duration, onComplete]);

    return (
        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '20px' }}>
            <div style={{ textAlign: 'center' }}>
                {/* Progress Bar Container */}
                <div style={{
                    width: '100%',
                    height: '8px',
                    backgroundColor: '#f3f3f3',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    margin: '0 auto 20px',
                    maxWidth: '400px'
                }}>
                    {/* Progress Bar Fill */}
                    <div style={{
                        height: '100%',
                        backgroundColor: '#3498db',
                        width: `${progress}%`,
                        transition: 'width 1s ease-in-out',
                        borderRadius: '4px'
                    }}></div>
                </div>

                {/* Loading Message */}
                <p style={{ color: '#666', fontSize: '16px' }}>
                    Loading your nutrition-optimized meal plan...
                </p>
            </div>
        </div>
    );
}